import { render, staticRenderFns } from "./MNumeric.vue?vue&type=template&id=67c32aa0"
import script from "./MNumeric.vue?vue&type=script&lang=js"
export * from "./MNumeric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports